// extracted by mini-css-extract-plugin
export default {"Logo":"style_Logo__W33fw","Logo__icon":"style_Logo__icon__81J4h","Logo__caption":"style_Logo__caption__ytNem","Logo__subtitle":"style_Logo__subtitle__ihnJA"};